/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import { IInternalRatingsServiceRepository } from '../interfaces/IInternalRatingsServiceRepository';
import { InternalRatingsServiceRepositoryImpl } from '../impls/InternalRatingsServiceRepositoryImpl';
import { TServicesParams } from '../types/TServicesParams';

export class InternalRatingsService implements IInternalRatingsServiceRepository {
    private oInternalRatingsServiceRepository: IInternalRatingsServiceRepository;

    constructor(params: TServicesParams) {
        this.oInternalRatingsServiceRepository = new InternalRatingsServiceRepositoryImpl(params);
    }

    async fetchAndStoreInternalRatingsData(): Promise<void> {
        return this.oInternalRatingsServiceRepository.fetchAndStoreInternalRatingsData();
    }

    getInternalRatingName(ratingKey: string): string {
        return this.oInternalRatingsServiceRepository.getInternalRatingName(ratingKey);
    }
}
